var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { injectable } from 'inversify';
import { validateOrReject } from 'class-validator';
var PlatformsService = /** @class */ (function () {
    function PlatformsService() {
        this.baseEndpoint = '/api/v1';
        this.endpoint = this.baseEndpoint + "/platforms";
        this.platformRoomsEndpoint = this.baseEndpoint + "/platform-rooms";
        this.surroundingsEndpoint = this.baseEndpoint + "/surroundings";
        this.neighbourhoodInvitationEndpoint = '/api/v1/neighbourhood-invitations';
        this.platformUserEndpoint = this.baseEndpoint + "/platform-users";
    }
    PlatformsService.prototype.createPlatform = function (platform) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, validateOrReject(platform)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, axios.post(this.endpoint, platform.toRestModel())];
                }
            });
        });
    };
    PlatformsService.prototype.updatePlatform = function (platform) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, validateOrReject(platform)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, axios.patch(this.endpoint + "/" + platform.uuid, platform.toRestModel())];
                }
            });
        });
    };
    PlatformsService.prototype.updatePlatformUserRole = function (platformUuid, user_id, platform_role) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.patch(this.endpoint + "/" + platformUuid + "/roles", { user_id: user_id, platform_role: platform_role })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PlatformsService.prototype.updatePlatformLogo = function (platformUuid, file) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append('logo', file);
                        formData.append('_method', 'PATCH');
                        return [4 /*yield*/, axios.post(this.endpoint + "/" + platformUuid + "/logo", formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PlatformsService.prototype.updatePlatformProfileImage = function (platformUuid, file) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append('profile_image', file);
                        formData.append('_method', 'PATCH');
                        return [4 /*yield*/, axios.post(this.endpoint + "/" + platformUuid + "/profile-image", formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PlatformsService.prototype.addImage = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append('file', file);
                        return [4 /*yield*/, axios.post(this.baseEndpoint + "/attachments", formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                },
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PlatformsService.prototype.leavePlatform = function (platformUserId, platformId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios.delete(this.platformUserEndpoint + "/" + platformUserId + "/" + platformId)];
            });
        });
    };
    PlatformsService.prototype.addSurroundings = function (platform, surroundingPlatforms) {
        var _this = this;
        return Promise.all(surroundingPlatforms.map(function (surroundingPlatform) { return _this.addSurrounding(platform, surroundingPlatform); }));
    };
    PlatformsService.prototype.addSurrounding = function (platform, surroundedPlatform) {
        return __awaiter(this, void 0, void 0, function () {
            var platformId, surroundedPlatformId, res, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        platformId = platform.id;
                        surroundedPlatformId = surroundedPlatform.id;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, validateOrReject('addSurrounding', { platformId: platformId, surroundedPlatformId: surroundedPlatformId })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, axios.post(this.surroundingsEndpoint, {
                                platform_id: platformId,
                                surrounded_platform_id: surroundedPlatformId,
                            })];
                    case 3:
                        res = _a.sent();
                        return [2 /*return*/, { platform: surroundedPlatform, res: res.data.data }];
                    case 4:
                        e_1 = _a.sent();
                        return [2 /*return*/, { platform: surroundedPlatform, res: e_1 }];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    PlatformsService.prototype.removeSurroundings = function (surroundings) {
        var _this = this;
        return Promise.all(surroundings.map(function (s) { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeSurrounding(s)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, { surrounding: s, res: res }];
                }
            });
        }); }));
    };
    PlatformsService.prototype.removeSurrounding = function (surrounding) {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.delete(this.surroundingsEndpoint + "/" + surrounding.uuid).then(function (r) { return r.data; })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/, e_2];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PlatformsService.prototype.deletePlatform = function (uuid) {
        return axios.delete(this.endpoint + "/" + uuid);
    };
    PlatformsService.prototype.activateSurrounding = function (surroundingUuid) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.post(this.surroundingsEndpoint + "/activate/" + surroundingUuid)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PlatformsService.prototype.deactivateSurrounding = function (surroundingUuid) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.delete(this.surroundingsEndpoint + "/activate/" + surroundingUuid)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PlatformsService.prototype.addPlatformRooms = function (platformId, roomNames) {
        var _this = this;
        if (roomNames.length) {
            return Promise.all(roomNames.map(function (name) { return __awaiter(_this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, axios.post(this.platformRoomsEndpoint, { platform_id: platformId, name: name })];
                        case 1:
                            data = (_a.sent()).data;
                            return [2 /*return*/, data.data];
                    }
                });
            }); }));
        }
        return [];
    };
    PlatformsService.prototype.removePlatformRooms = function (platformRoomUuid) {
        var _this = this;
        if (platformRoomUuid.length) {
            return Promise.all(platformRoomUuid.map(function (uuid) { return axios.delete(_this.platformRoomsEndpoint + "/" + uuid); }));
        }
    };
    PlatformsService.prototype.neighbourhoodInvitationEmail = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.post("" + this.neighbourhoodInvitationEndpoint, { email: email })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PlatformsService.prototype.neighbourhoodInvitationLink = function (platformUuid) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.get(this.neighbourhoodInvitationEndpoint + "/" + platformUuid + "/generate")];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PlatformsService = __decorate([
        injectable()
    ], PlatformsService);
    return PlatformsService;
}());
export { PlatformsService };
